<template>
  <div>
    <b-card>
      <b-row class="d-flex align-items-center justify-content-center">
        <b-col
          v-for="item in dataList"
          :key="item.id"
          class="text-center mb-2"
          cols="6"
          md="3"
        >
          <div class="bg-light w-100 height-200 d-flex align-items-center justify-content-center border-light rounded mb-1 pt-2 pb-2">
            <b-img
              :src="baseUrl + '/media/vehicle_types/' + item.image"
              fluid
              style="max-height: 100px; max-width: 200px"
            />
          </div>
          <b-form-checkbox
            v-model="dataItem.vehicle_types"
            :value="item.id"
            inline
          >
            <span class="font-small-2">
              {{ item.title }}
            </span>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BFormCheckbox, BImg,
} from 'bootstrap-vue'

export default {
  name: 'VehicleTypes',
  components: {
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BImg,
  },
  data() {
    return {
      baseUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    dataList() {
      return this.$store.getters['vehicleTypes/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('vehicleTypes/getDataList')
    },
  },
}
</script>
